import React, {useState} from "react";
import {Form, Formik} from "formik";
import "./index.scss"
import {Button} from "../../Button";
import {strings} from "../../../strings/strings";
import {addYears} from "../../../utils/dateUtils";
import {InputTextMask} from "../../inputs/InputTextMask";
import {FormItem} from "../../inputs/FormItem";
import {DatePicker} from "../../inputs/DatePicker";


interface IMTPLPhoneNumberDialogProps {
    isOpen: boolean;
    onSubmit: (values: {
        phone: string,
        birthDate: Date,
    }) => Promise<void>;
}

export const MTPLPhoneNumberDialog = (props: IMTPLPhoneNumberDialogProps) => {
    const {isOpen} = props;
    const [process, setProcess] = useState(false);
    const onSubmit = async (values) => {
        setProcess(true);
        await props.onSubmit(values);
        setProcess(false);
    }

    return (
        <div>
            {isOpen &&
            <div className={"dialog-one"}>
                <Formik
                    initialValues={{
                        phone: '',
                        birthDate: null,
                    }}
                    onSubmit={onSubmit}
                    validateOnBlur={false}
                    validateOnChange={false}
                >
                    {formProps => (
                        <Form>
                            <div className="dialog-one__content">
                                <span className={"dialog-one__title"}>{strings.mtplPhoneNumberDlg.text1}</span>
                                <FormItem name={'phone'} validation={{isRequired: true}}>
                                    <InputTextMask
                                        label={strings.personalInfoLivingPhone}
                                        mask={"+38(999)999-99-99"}
                                    />
                                </FormItem>
                                <FormItem name={'birthDate'} validation={{isRequired: true}}>
                                    <DatePicker
                                        label={strings.personalInfoBirthDate }
                                        placeholder={strings.datePlaceholder}
                                        minDate={addYears(new Date(), -100)}
                                        maxDate={addYears(new Date(), -18)}
                                    />
                                </FormItem>

                                <Button id={'toolbarCheck'}
                                        label={strings.toolbarCheck}
                                        isProcess={process}
                                        onClickListener={formProps.handleSubmit}/>

                                <div className={"vehicle-search-view__search__help"}>
                                    <span>{strings.mtplPhoneNumberDlg.text2}</span>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
            }
        </div>
    )

}